import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

export const OptionConstants = {
  w: 880,
  h: 80,
  margin: 5,
};

export class OptionItem extends Lightning.Component {
  static _template() {
    const margin2 = OptionConstants.margin * 2;
    const margin4 = OptionConstants.margin * 4;
    return {
      rect: true,
      color: Theme.Colors.Transparent,
      h: OptionConstants.h,
      w: OptionConstants.w,
      Background: {
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 10,
        },
        rect: true,
        x: OptionConstants.margin,
        y: OptionConstants.margin,
        w: OptionConstants.w - margin2,
        h: OptionConstants.h - margin2,
        color: Theme.Colors.Option.Background.Item,
      },
      Label: {
        x: OptionConstants.margin,
        y: OptionConstants.margin * 0.5,
        w: OptionConstants.w - margin4,
        h: OptionConstants.h - margin2,

        text: {
          ...Theme.Fonts.Option.Item,
          advancedRenderer: true,
          verticalAlign: 'middle',
          lineHeight: OptionConstants.h - margin2,
          textColor: Theme.Colors.Option.Text.Normal,
        },
      },
      CenterIcon: {
        x: OptionConstants.w * 0.5,
        y: OptionConstants.h * 0.5,
        // w: OptionConstants.w,
        // h: OptionConstants.h,
        mount: 0.5,
        visible: false,
      },
    };
  }

  /**
   * @param {OptionData} data
   */
  set data(data) {
    const label = this.tag('Label');
    const icon = this.tag('CenterIcon');
    const hasIcon = data.icon;
    this._data = data;
    label.text.text = data.text;
    icon.src = data.icon;
    if (data.selected) {
      icon.color = Theme.Colors.Option.Text.Selected;
      label.text.textColor = Theme.Colors.Option.Text.Selected;
    }
    label.visible = !hasIcon;
    icon.visible = hasIcon;
  }

  get data() {
    return this._data;
  }

  get label() {
    return this._data.text;
  }

  _focus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Focus);
    this.tag('Label').text.textColor = Theme.Colors.Option.Text.Normal;
  }

  _unfocus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Item);
    if (this._data.selected) {
      this.tag('Label').text.textColor = Theme.Colors.Option.Text.Selected;
    }
  }

  _handleEnter() {
    this.signal('onActivate', this);
  }
}
